<template>
  <div>
    <!-- MAIN EDITOR MODAL -->
    <div v-show="isOpen" class="role-editor-overlay" @mousedown.self="close">
      <div v-if="currentView === 'main'" class="role-editor-modal">
        <div class="modal-header">
          <h2 class="modal-title">
            {{ mode === 'CREATE' ? $t('orgDashboard.userDashboard.evaluation.addnewrole') : $t('orgDashboard.userDashboard.evaluation.editrole') }}
          </h2>
          <div class="header-right">
            <!-- NEW METRICS ICON -->
            <!-- <button class="settings-icon-btn" @click="openMetricsView" title="Configure Metrics & Salary">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>
            </button> -->

            <div class="kvdr-badge" :class="kvdrTag.toLowerCase()" @click="currentView = 'detection'">
              {{ kvdrTag }}
              <span class="badge-tooltip">{{ getTagDescription }}</span>
            </div>
            <button class="close-btn" @click="close">&times;</button>
          </div>
        </div>

        <div class="modal-body">
          <!-- Assigned Candidates -->
          <div v-if="mode === 'EDIT' && form.profiles && form.profiles.length > 0" class="assigned-candidates-section">
              <div class="candidate-avatars">
                  <div v-for="user in form.profiles" :key="user.id || user.userId" class="avatar-wrapper" @click="openInlineTalentCard(user.id || user.userId)">
                    <img :src="getAvatarUrl(user)" class="candidate-avatar" />
                    <span class="tooltip">{{ user.name || user.firstName || 'User' }}</span>
                  </div>
              </div>
          </div>

          <!-- TWO-COLUMN LAYOUT -->
          <div class="main-layout-container">
              <!-- LEFT COLUMN -->
              <div class="main-content-column">
                  
                  <!-- DESIGNATION / ROLE TITLE -->
                  <div class="title-level-wrapper">
                    <input type="text" v-model="form.title" :placeholder="$t('orgDashboard.userDashboard.evaluation.roleTitle')" class="designation-input minimal-title"/>
                    
                    <!-- CUSTOM LEVEL DROPDOWN -->
                    <div class="level-selector" v-click-outside="() => showLevelDropdown = false">
                        <button class="level-select-minimal" @click="showLevelDropdown = !showLevelDropdown">
                            {{ form.level || $t('orgDashboard.userDashboard.evaluation.selectlevel') }}
                        </button>
                        <span class="dropdown-caret">▼</span>
                        <ul v-if="showLevelDropdown" class="level-dropdown-menu">
                            <li v-for="lvl in orgLevels" :key="lvl.label || lvl" @click="selectLevel(lvl.label || lvl)">
                                {{ lvl.label || lvl }}
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- MINIMAL DESCRIPTION / MISSION -->
                <div class="form-group mission-group">
                    <textarea v-model="form.mission" :placeholder="$t('orgDashboard.userDashboard.evaluation.purpose')" class="minimal-mission-input auto-expand-textarea" @input="resizeTextarea"></textarea>
                </div>

                  <!-- RESPONSIBILITIES -->
                  <div class="form-group">
                      <div class="label-row-with-ai">
                          <label>{{ $t('orgDashboard.userDashboard.evaluation.responsibilities') }}</label>
                          <vs-tooltip :text="$t('orgDashboard.userDashboard.evaluation.generateroledescription')">
                              <button class="ai-icon-btn" @click.prevent="generateAIContent" :disabled="isGeneratingJD">
                                  <svg v-if="!isGeneratingJD" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/></svg>
                                  <span v-else class="loading-spinner"></span>
                              </button>
                          </vs-tooltip>
                      </div>
                      <div class="rich-text-toolbar">
                          <button @mousedown.prevent="formatText('bold')" title="Bold"><b>B</b></button>
                          <button @mousedown.prevent="formatText('italic')" title="Italic"><i>I</i></button>
                          <button @mousedown.prevent="formatText('underline')" title="Underline"><u>U</u></button>
                          <button @mousedown.prevent="formatText('insertUnorderedList')" title="Bullet List">•</button>
                          <select @mousedown.prevent @change="formatText('fontSize', $event.target.value)" title="Font Size">
                              <option value="3">Normal</option><option value="4">Large</option><option value="5">Huge</option>
                          </select>
                      </div>
                      <div class="rich-text-editor invisible-scroll-y" contenteditable="true" @blur="updateRichText('responsibilities', $event)" v-html="form.responsibilities"></div>
                  </div>

                  <!-- MISSION (JTBD) -->
                <div class="minimal-goals-section">
                    <label class="box-title">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle></svg> 
                        {{ $t('orgDashboard.userDashboard.evaluation.mission') }}
                    </label>
                    
                    <div class="form-group">
                        <input type="text" v-model="form.primaryGoal" :placeholder="$t('orgDashboard.userDashboard.evaluation.primarygoal')" class="minimal-underline-input"/>
                    </div>
                    <div class="form-group">
                        <input type="text" v-model="form.secondaryGoal" :placeholder="$t('orgDashboard.userDashboard.evaluation.secondarygoal')" class="minimal-underline-input"/>
                    </div>
                </div>
              </div>

              <!-- RIGHT COLUMN (Absolute Scrollable Skills) -->
            <div class="skills-column">
                
                <div class="form-group">
                    <div class="search-wrapper minimal-input-wrapper">
                        <input type="text" v-model="funcSkillSearch" :placeholder="$t('orgDashboard.userDashboard.evaluation.functionalSkills')" class="minimal-input" @keydown.enter.prevent="addSkillsFromInput('functional')" @focus="showFuncDropdown = true" @blur="showFuncDropdown = false" />
                        <span class="dropdown-caret">▼</span>
                        
                        <ul v-show="showFuncDropdown" class="side-dropdown-list invisible-scroll-y">
                            <li v-for="skill in filteredFuncSkills" :key="skill" @mousedown.prevent="addSkill('functional', skill)">
                                {{ skill }} <span v-if="form.skills.includes(skill)" class="check-icon">✓</span>
                            </li>
                            <li v-if="filteredFuncSkills.length === 0" class="no-results">No matches found</li>
                        </ul>
                    </div>

                    <div class="tags-container">
                        <span v-for="(skill, index) in form.skills" :key="'f-'+index" class="skill-tag">
                            {{ skill }} <span class="remove-skill" @click="removeSkill('functional', index)">&times;</span>
                        </span>
                    </div>
                </div>

                <div class="form-group">
                    <div class="search-wrapper minimal-input-wrapper">
                        <input type="text" v-model="softSkillSearch" :placeholder="$t('orgDashboard.userDashboard.evaluation.softSkills')" class="minimal-input" @keydown.enter.prevent="addSkillsFromInput('soft')" @focus="showSoftDropdown = true" @blur="showSoftDropdown = false" />
                        <span class="dropdown-caret">▼</span>
                        
                        <ul v-show="showSoftDropdown" class="side-dropdown-list invisible-scroll-y">
                            <li v-for="skill in filteredSoftSkills" :key="skill" @mousedown.prevent="addSkill('soft', skill)">
                                {{ skill }} <span v-if="form.softSkills.includes(skill)" class="check-icon">✓</span>
                            </li>
                            <li v-if="filteredSoftSkills.length === 0" class="no-results">No matches found</li>
                        </ul>
                    </div>

                    <div class="tags-container">
                        <span v-for="(skill, index) in form.softSkills" :key="'s-'+index" class="skill-tag">
                            {{ skill }} <span class="remove-skill" @click="removeSkill('soft', index)">&times;</span>
                        </span>
                    </div>
                </div>

            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn-secondary" @click="openJDPreview">{{ $t('orgDashboard.userDashboard.evaluation.previewanddownload') }}</button>
          <button class="btn-primary" @click="saveRole">
            {{ mode === 'CREATE' ? $t('orgDashboard.userDashboard.evaluation.createrole') : $t('orgDashboard.userDashboard.evaluation.saveChanges') }}
          </button>
        </div>
      </div>

      <!-- DETECTION LAYER VIEW -->
      <div v-if="currentView === 'detection'" class="role-editor-modal detection-modal">
          <div class="modal-header">
              <h2 class="modal-title">{{ $t('orgDashboard.userDashboard.evaluation.kvdrdetection') }}</h2>
              <button class="close-btn" @click="currentView = 'main'">&times;</button>
          </div>
          <div class="modal-body">
    <!-- NEW CLASSIFICATION BOX -->
    <div class="classification-box" :class="kvdrTag.toLowerCase()">
        <div class="class-left">
            <div class="class-label">{{ $t('orgDashboard.userDashboard.evaluation.currentclassification') }}</div>
            <div class="class-val">{{ kvdrTag }}</div>
            <div class="class-desc">{{ getTagDescription }}</div>
        </div>
        <div class="class-right">
            <div class="class-label">{{ $t('orgDashboard.userDashboard.evaluation.influence') }}</div>
            <div class="class-score"><span>{{ form.kvdr.influenceScore }}</span>/5</div>
        </div>
    </div>

    <!-- NEW VALUE DRIVER BUTTONS -->
    <div class="form-group">
        <label>{{ $t('orgDashboard.userDashboard.evaluation.whatdrivesthisrole') }}</label>
        <div class="btn-group">
            <button :class="{'active': form.kvdr.valueDriver === 'Person'}" @click="form.kvdr.valueDriver = 'Person'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                {{ $t('orgDashboard.userDashboard.evaluation.person') }}
            </button>
            <button :class="{'active': form.kvdr.valueDriver === 'Role'}" @click="form.kvdr.valueDriver = 'Role'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22v-5"/><path d="M16 17H8"/><path d="M20 17H4"/><path d="m4 12 8-10 8 10"/><path d="M2 12h20"/></svg>
                {{ $t('orgDashboard.userDashboard.evaluation.role') }}
            </button>
        </div>
    </div>

    <!-- NEW VALUE KIND PILLS -->
    <div class="form-group">
        <label>{{ $t('orgDashboard.userDashboard.evaluation.whatkidnofvalue') }}</label>
        <div class="pill-group">
            <button v-for="tag in ['Revenue', 'Cost', 'Risk', 'Ops', 'Brand', 'Social', 'Research', 'IP']" :key="tag"
                    class="pill" :class="{'active': form.kvdr.valueTags.includes(tag)}"
                    @click="toggleArrayItem(form.kvdr.valueTags, tag)">
                {{ $t('orgDashboard.userDashboard.evaluation.' + tag.toLowerCase()) }}
            </button>
            <button class="pill" :class="{'active': form.kvdr.valueTags.includes('Other')}"
                    @click="toggleArrayItem(form.kvdr.valueTags, 'Other')">
                {{ $t('orgDashboard.userDashboard.evaluation.other') }}
            </button>
        </div>
        <!-- Note: Placeholder for input is kept manual because it is a typed response -->
        <input v-if="form.kvdr.valueTags.includes('Other')" type="text" v-model="form.kvdr.otherValueText" placeholder="Specify other value..." class="form-control other-value-input"/>
    </div>

    <!-- NEW BUSINESS TERMS CHECKBOXES -->
    <div class="form-group">
        <label>{{ $t('orgDashboard.userDashboard.evaluation.canthisvalue') }}</label>
        <div class="grid-2">
            <label class="checkbox-button" v-for="expr in ['Revenue generated', 'Cost saved', 'Time reduced', 'Risk mitigated', 'Quality improved', 'Capability built']" :key="expr">
                <input type="checkbox" :value="expr" v-model="form.kvdr.businessExpressions">
                <div class="checkbox-content">
                    <span class="custom-check">
                      <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </span>
                    <!-- Map array strings to their respective translation keys -->
                    {{ expr === 'Revenue generated' ? $t('orgDashboard.userDashboard.evaluation.revenue') : $t('orgDashboard.userDashboard.evaluation.' + expr.replace(' ', '').toLowerCase()) }}
                </div>
            </label>
        </div>
    </div>

    <!-- NEW SLIDERS -->
    <div class="form-group">
        <label>{{ $t('orgDashboard.userDashboard.evaluation.valueinfluencescore') }} <span class="score-badge">{{ form.kvdr.influenceScore }}/5</span></label>
        <input type="range" min="1" max="5" v-model.number="form.kvdr.influenceScore" class="slider orange-slider" @input="updateSliderStyle">
        <div class="slider-labels">
            <span>{{ $t('orgDashboard.userDashboard.evaluation.noinfluence') }}</span>
            <span>{{ $t('orgDashboard.userDashboard.evaluation.directdriver') }}</span>
        </div>
    </div>

    <div class="form-group">
        <label>{{ $t('orgDashboard.userDashboard.evaluation.ownershipclarity') }} <span class="score-badge">{{ form.kvdr.ownershipClarity }}/5</span></label>
        <input type="range" min="1" max="5" v-model.number="form.kvdr.ownershipClarity" class="slider orange-slider" @input="updateSliderStyle">
        <div class="slider-labels">
            <span>{{ $t('orgDashboard.userDashboard.evaluation.diffuse') }}</span>
            <span>{{ $t('orgDashboard.userDashboard.evaluation.clear') }}</span>
        </div>
    </div>
</div>
          <div class="modal-footer">
            <button class="btn-secondary" @click="currentView = 'main'">{{ $t('orgDashboard.userDashboard.evaluation.back') }}</button>
            <button class="btn-primary" @click="saveDetectionMetrics" :disabled="isSavingKvdr">
                {{ isSavingKvdr ? 'Saving...' : $t('orgDashboard.userDashboard.evaluation.done') }}
            </button>
            </div>
      </div>
    </div>
    <!-- METRICS & COMPENSATION POPUP (Floating on top) -->
    <div v-if="showMetricsModal" class="role-editor-overlay metrics-overlay" @mousedown.self="validateAndCloseMetrics">
      <div class="metrics-inner-modal">
          <div class="modal-header">
              <h2 class="modal-title">Metrics & Compensation</h2>
              <button class="close-btn" @click="validateAndCloseMetrics">&times;</button>
          </div>
          
          <div class="modal-body" style="padding: 24px;">
              <!-- Salary Box -->
              <div class="form-group-box bg-white shadow-sm border border-gray-200">
                  <div class="box-title text-base">Compensation Range</div>
                  <p class="text-sm text-gray-500 mb-4">Define the salary band for this role. Pre-filled from Organization settings if already configured.</p>
                  
                  <div class="grid-2">
                      <div class="form-group">
                          <label>Minimum Salary</label>
                          <div class="input-with-currency">
                              <span class="currency-symbol">$</span>
                              <input type="number" v-model.number="form.minSalary" placeholder="0.00" class="form-control font-semibold text-gray-800" />
                          </div>
                      </div>
                      <div class="form-group">
                          <label>Maximum Salary</label>
                          <div class="input-with-currency">
                              <span class="currency-symbol">$</span>
                              <input type="number" v-model.number="form.maxSalary" placeholder="0.00" class="form-control font-semibold text-gray-800" />
                          </div>
                      </div>
                  </div>
              </div>

              <!-- Metrics Box -->
              <div class="form-group-box bg-white shadow-sm border border-gray-200 mt-6">
                  <div class="flex justify-between items-center mb-2">
                      <div class="box-title text-base mb-0">Role Evaluation Criteria</div>
                      <div class="score-badge" :class="tempTotalMetricWeight === 100 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                        Total Weight: {{ tempTotalMetricWeight }}%
                    </div>
                  </div>
                  <p class="text-sm text-gray-500 mb-4">Allocate weights to the global criteria specific to this role. The total must equal 100%.</p>

                  <div v-if="!tempMetrics || tempMetrics.length === 0" class="text-sm text-gray-400 italic">
                      Loading organizational metrics...
                  </div>

                  <div class="metrics-list-container">
                      <!-- FIX: Use tempMetrics here -->
                      <div v-for="(metric, idx) in tempMetrics" :key="idx" class="metric-row group">
                          <div class="metric-info pr-4 flex-1">
                              <div class="font-bold text-gray-800 text-sm">{{ metric.name }}</div>
                              <div class="text-xs text-gray-500 italic mt-1">{{ metric.desc }}</div>
                          </div>
                          
                          <div class="flex items-center justify-end gap-1">
                              <div class="metric-weight-input flex items-center">
                                  <!-- FIX: Use tempMetrics here too -->
                                  <input type="number" v-model.number="tempMetrics[idx].weight" min="0" max="100" class="minimal-underline-input text-center font-bold text-lg w-12 mr-1" />
                                  <span class="text-gray-500 font-bold mr-3">%</span>
                              </div>
                              
                              <button class="action-icon-btn edit-btn" @click="openRoleMetricEditor(idx)" title="Edit Criteria">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                              </button>
                              
                              <button class="action-icon-btn delete-btn" @click="removeRoleMetric(idx)" title="Delete Criteria">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                              </button>
                          </div>
                      </div>
                  </div>

                  <!-- Add Custom Metric Button -->
                  <button class="add-metric-dashed-btn mt-4" @click="openRoleMetricEditor(-1)">
                      + Add Custom Criteria
                  </button>
              </div>
          </div>
          
          <div class="modal-footer">
            <button class="btn-secondary" @click="cancelMetricsModal">Cancel</button> <!-- FIX THIS LINE -->
            <button class="btn-primary" @click="validateAndCloseMetrics">Save</button>
          </div>
      </div>
    </div>  
    <!-- NESTED METRIC EDITOR POPUP -->
    <div v-if="showRoleMetricEditor" class="role-editor-overlay" style="z-index: 26000;" @mousedown.self="closeRoleMetricEditor">
      <div class="metrics-inner-modal" style="width: 450px;">
          <div class="modal-header">
              <h2 class="modal-title">{{ editingMetricIndex === -1 ? 'Add Custom Criteria' : 'Edit Criteria' }}</h2>
              <button class="close-btn" @click="closeRoleMetricEditor">&times;</button>
          </div>
          <div class="modal-body" style="padding: 24px;">
              <div class="form-group mb-4">
                  <label class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Criteria Name</label>
                  <input type="text" v-model="tempMetric.name" placeholder="e.g. Creative Thinking" class="form-control font-semibold" />
              </div>
              <div class="form-group">
                  <label class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Description</label>
                  <!-- FIX: Removed auto-expand-textarea, added min-height -->
                  <textarea v-model="tempMetric.desc" placeholder="What does this evaluate?" class="form-control text-sm" style="min-height: 100px; resize: vertical; line-height: 1.5;"></textarea>
              </div>
          </div>
          <div class="modal-footer">
              <button class="btn-secondary" @click="closeRoleMetricEditor">Cancel</button>
              <button class="btn-primary" @click="saveRoleMetricEditor">Save</button>
          </div>
      </div>
    </div>

    <!-- SEPARATE JD PREVIEW POPUP -->
    <div v-if="showJDModal" class="role-editor-overlay jd-preview-overlay" @mousedown.self="showJDModal = false">
      <div class="jd-preview-modal">
        <div class="modal-header">
            <h2 class="modal-title">Job Description Preview</h2>
            <button class="close-btn" @click="showJDModal = false">&times;</button>
        </div>
        
        <!-- Elegant Download Toolbar -->
        <div class="jd-toolbar">
            <span class="toolbar-label">Download As:</span>
            <button class="dl-btn" @click="downloadJD('txt')">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> TXT
            </button>
            <button class="dl-btn" @click="downloadJD('doc')">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M9 15l2 2 4-4"></path></svg> Word
            </button>
            <button class="dl-btn" @click="downloadJD('pdf')">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M9 15v-4h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9z"></path></svg> PDF
            </button>
        </div>

        <div class="modal-body jd-body">
            <div class="rich-text-editor readonly-jd" v-html="generatedJD"></div>
        </div>
      </div>
    </div>
    <TalentCardPreview 
      ref="talentCardRef" 
      :userId="selectedTalentId" 
      :hideTrigger="true" 
    />
  </div>
</template>

<script>
import allFunctionalSkills from '@/assets/data/all-skills.js';
import allSoftSkills from '@/assets/data/all-personality.js';
import TalentCardPreview from './TalentCardPreview.vue';

export default {
    name: 'RoleEvaluationModal',
    components: {
        TalentCardPreview
    },
    directives: {
        'click-outside': {
            bind(el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    // Check that click was outside the el and its children
                    if (!(el === event.target || el.contains(event.target))) {
                        // Correctly evaluate inline functions or string method names
                        if (typeof binding.value === 'function') {
                            binding.value(event);
                        } else if (vnode.context && typeof vnode.context[binding.expression] === 'function') {
                            vnode.context[binding.expression](event);
                        }
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            },
        }
    },
    data() {
        return {
            isOpen: false,
            showMetricsModal: false,
            showRoleMetricEditor: false,
            editingMetricIndex: -1,
            tempMetrics: [],
            tempMetric: { name: '', desc: '', weight: 0 },
            selectedTalentId: null,
            showLevelDropdown: false,
            currentView: 'main',
            mode: 'CREATE',
            onSaveCallback: null,
            isGeneratingJD: false,
            generatedJD: '',
            showJDModal: false, 
            isSavingKvdr: false,
            funcSkillSearch: '',
            softSkillSearch: '',
            showFuncDropdown: false,
            showSoftDropdown: false,
            
            orgLevels: [], 

            masterFuncSkills: allFunctionalSkills || [],
            masterSoftSkills: allSoftSkills || [],

            form: {
                selfId: null,
                title: '',
                level: '', 
                minSalary: null,    // <-- ADDED
                maxSalary: null,    // <-- ADDED
                evaluationMetrics: [],
                mission: '',
                responsibilities: '', 
                primaryGoal: '',
                secondaryGoal: '',
                skills: [],
                softSkills: [],
                profiles: [],    
                kvdr: {
                    valueDriver: '', valueTags: [], businessExpressions: [], 
                    influenceScore: 1, ownershipClarity: 3, otherValueText: '' 
                }
            }
        }
    },
    computed: {
        totalMetricWeight() {
            return this.form.evaluationMetrics.reduce((sum, m) => sum + (Number(m.weight) || 0), 0);
        },
        tempTotalMetricWeight() {
            if (!this.tempMetrics) return 0;
            return this.tempMetrics.reduce((sum, m) => sum + (Number(m.weight) || 0), 0);
        },
        filteredFuncSkills() {
            if(!this.funcSkillSearch) return this.masterFuncSkills.slice(0, 50);
            const searchTerms = this.funcSkillSearch.split(',').map(s => s.trim());
            const currentSearch = searchTerms[searchTerms.length - 1].toLowerCase();
            if (!currentSearch) return this.masterFuncSkills.slice(0, 50);
            return this.masterFuncSkills.filter(s => s && s.toLowerCase().includes(currentSearch)).slice(0, 50);
        },
        filteredSoftSkills() {
            if(!this.softSkillSearch) return this.masterSoftSkills;
            const searchTerms = this.softSkillSearch.split(',').map(s => s.trim());
            const currentSearch = searchTerms[searchTerms.length - 1].toLowerCase();
            if (!currentSearch) return this.masterSoftSkills;
            return this.masterSoftSkills.filter(s => s && s.toLowerCase().includes(currentSearch));
        },
        kvdrTag() {
            const inf = this.form.kvdr.influenceScore;
            const bizLen = this.form.kvdr.businessExpressions.length;
            if (inf >= 4 && bizLen >= 1) return 'KVDR';
            if (inf >= 2) return 'SVR';
            return 'NVR';
        },
        clarityScore() {
            let score = 0;
            score += this.form.kvdr.valueDriver ? 1 : 0;
            score += this.form.kvdr.valueTags.length >= 1 ? 1 : 0;
            score += this.form.kvdr.businessExpressions.length >= 1 ? 1 : 0;
            score += this.form.primaryGoal && this.form.primaryGoal.trim() !== '' ? 1 : 0;
            score += this.form.kvdr.influenceScore >= 4 ? 0.5 : 0;
            score += this.form.kvdr.ownershipClarity >= 4 ? 0.5 : 0;
            return Math.round(Math.min(5, score));
        },
        getTagDescription() {
        if (this.kvdrTag === 'KVDR') return this.$t('orgDashboard.userDashboard.evaluation.kvdr');
        if (this.kvdrTag === 'SVR') return this.$t('orgDashboard.userDashboard.evaluation.svr');
        return this.$t('orgDashboard.userDashboard.evaluation.nvr');
    }
    },
    methods: {
        openMetricsView() {
            // 1. Normalize the current level string to check it safely
            const currentLevel = this.form.level ? String(this.form.level).trim().toLowerCase() : '';

            // 2. BLOCK IF LEVEL IS EMPTY OR SET TO "UNASSIGNED"
            if (!currentLevel || currentLevel === '' || currentLevel === 'unassigned' || currentLevel === 'select level') {
                if (this.$vs) {
                    this.$vs.notify({ 
                        title: 'Level Required', 
                        text: 'Please select a valid Role Level before configuring compensation and metrics.', 
                        color: 'warning',
                        time: 4000
                    });
                }
                return; // Stops the function here, popup will NOT open
            }
            
            // 3. Clone the array to tempMetrics so edits don't lag or auto-save
            this.tempMetrics = JSON.parse(JSON.stringify(this.form.evaluationMetrics));
            this.showMetricsModal = true; 
        },

        cancelMetricsModal() {
            // Discard changes
            this.tempMetrics = [];
            this.showMetricsModal = false;
        },
        
        validateAndCloseMetrics() {
            // Calculate total from TEMP metrics
            const currentTotal = this.tempMetrics.reduce((sum, m) => sum + (Number(m.weight) || 0), 0);

            if (currentTotal !== 100 && currentTotal !== 0) {
                if (this.$vs) {
                    this.$vs.notify({ 
                        title: 'Invalid Weights', 
                        text: `Total weight must be 100%. Currently it is ${currentTotal}%.`, 
                        color: 'warning' 
                    });
                }
                return;
            }
            // Apply changes to main form
            this.form.evaluationMetrics = JSON.parse(JSON.stringify(this.tempMetrics));
            this.showMetricsModal = false; 
        },

        openRoleMetricEditor(index) {
            this.editingMetricIndex = index;
            if (index === -1) {
                this.tempMetric = { name: '', desc: '', weight: 0 };
            } else {
                this.tempMetric = { ...this.tempMetrics[index] };
            }
            this.showRoleMetricEditor = true;
        },

        closeRoleMetricEditor() {
            this.showRoleMetricEditor = false;
        },

        saveRoleMetricEditor() {
            if (!this.tempMetric.name.trim()) {
                if (this.$vs) this.$vs.notify({ title: 'Required', text: 'Criteria name is required.', color: 'warning' });
                return;
            }

            if (this.editingMetricIndex === -1) {
                this.tempMetrics.push({ ...this.tempMetric });
            } else {
                this.tempMetrics.splice(this.editingMetricIndex, 1, { ...this.tempMetric });
            }
            this.closeRoleMetricEditor();
        },

        removeRoleMetric(index) {
            const metricName = this.tempMetrics[index].name || 'this criteria';
            
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirm Deletion',
                text: `Are you sure you want to remove "${metricName}" from this role?`,
                acceptText: 'Delete',
                cancelText: 'Cancel',
                accept: () => {
                    // Vue will now instantly detect this and update the UI
                    this.tempMetrics.splice(index, 1);
                    
                    // Optional: Show a quick success toast so the user knows it worked
                    if (this.$vs) {
                        this.$vs.notify({ title: 'Removed', text: 'Criteria deleted.', color: 'success' });
                    }
                }
            });
        },

        async fetchGlobalMetrics() {
            try {
                const orgId = this.$store.state.organization.orgData._id;
                const token = localStorage.getItem('accessToken');
                const apiUrl = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000';
                const res = await fetch(`${apiUrl}/api/v2/organization/${orgId}/evaluation-factors`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (res.ok) {
                    const json = await res.json();
                    return json.data || [];
                }
            } catch (e) { console.error("Failed to fetch global metrics", e); }
            return [];
        },
        openInlineTalentCard(userId) {
            if (!userId) return;
            this.selectedTalentId = userId;
            
            // Wait for DOM to update the userId prop, then call the open function
            this.$nextTick(() => {
                if (this.$refs.talentCardRef) {
                    this.$refs.talentCardRef.openTalentCard();
                }
            });
        },
        selectLevel(level) {
            this.form.level = level;
            this.showLevelDropdown = false; // Select a level and close the dropdown
        },
        updateSliderStyle(event) {
            const slider = event.target;
            const min = slider.min;
            const max = slider.max;
            const val = slider.value;
            const percentage = ((val - min) * 100) / (max - min);
            slider.style.setProperty('--fill-percent', `${percentage}%`);
        }, 
        async open(payload) {
            this.mode = payload.mode || 'CREATE';
            this.onSaveCallback = payload.onSave;
            this.currentView = 'main';
            this.generatedJD = '';
            this.showJDModal = false;
            this.funcSkillSearch = '';
            this.softSkillSearch = '';
            this.showFuncDropdown = false;
            this.showSoftDropdown = false;

            const role = payload.role || {};
            await this.fetchLevels();
            const globalMetrics = await this.fetchGlobalMetrics();

            let summaryText = role.responsibilities || role.roleSummary || '';
            if (!summaryText && Array.isArray(role.description) && role.description.length > 0) {
                 const lastEntry = [...role.description].reverse().find(d => d && typeof d.msg === 'string');
                 if (lastEntry) summaryText = lastEntry.msg.replace('[ROLE_DESC_SAVE]', '');
            }
            
            const nvrDefault = {
                valueDriver: '', valueTags: [], businessExpressions: [], 
                influenceScore: 1, ownershipClarity: 3, otherValueText: ''
            };

            let finalKvdr = { ...nvrDefault, ...(role.kvdr || {}) };

            if (role.selfId && this.mode === 'EDIT') {
                try {
                    const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
                    // const apiUrl = process.env.VUE_APP_API_URL;
                    const apiUrl = process.env.VUE_APP_API_URL;
                    const res = await fetch(`${apiUrl}/api/v2/roles/${role.selfId}/kvdr-metrics`, { headers: { 'Authorization': `Bearer ${token}` } });
                    if (res.ok) {
                        const json = await res.json();
                        // FIX: Added safe access checks to prevent "Cannot read properties of null"
                        if (json && json.data && json.data.kvdr) {
                            finalKvdr = { ...nvrDefault, ...json.data.kvdr };
                        }
                    }
                } catch (e) { console.warn("Could not fetch KVDR metrics"); }
            }

            // --- FIX: FETCH LEVEL FROM PYTHON DB ON OPEN ---
            let savedLevel = role.level || '';
            let savedMin = null;
            let savedMax = null;
            let savedMetrics = [];

            if (role.selfId && this.mode === 'EDIT') {
                try {
                    const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
                    const apiUrl = process.env.VUE_APP_API_URL;
                    
                    // 1. Fetch KVDR Safely
                    const res = await fetch(`${apiUrl}/api/v2/roles/${role.selfId}/kvdr-metrics`, { headers: { 'Authorization': `Bearer ${token}` } });
                    if (res.ok) {
                        const json = await res.json();
                        // 🚀 ULTRA-SAFE CHECK: Ensures json.data is an actual object before reading .kvdr
                        if (json && json.data && typeof json.data === 'object' && json.data.kvdr) {
                            finalKvdr = { ...nvrDefault, ...json.data.kvdr };
                        }
                    }
                    
                    // 2. Fetch Salary & Weights Metadata Safely
                    const metaRes = await fetch(`${apiUrl}/api/v2/roles/${role.selfId}/metadata`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (metaRes.ok) {
                        const metaJson = await metaRes.json();
                        // 🚀 ULTRA-SAFE CHECK: Ensures metaJson.data is an actual object
                        if (metaJson && metaJson.data && typeof metaJson.data === 'object') {
                            savedLevel = metaJson.data.level || savedLevel;
                            savedMin = metaJson.data.min_salary ? parseFloat(metaJson.data.min_salary) : null;
                            savedMax = metaJson.data.max_salary ? parseFloat(metaJson.data.max_salary) : null;
                            savedMetrics = metaJson.data.evaluation_metrics || [];
                        }
                    }
                } catch (e) { 
                    console.warn("Could not fetch metadata safely:", e); 
                }
            }

            // Map metrics securely so Vue tracks the "weight" updates
            let finalMetrics = [];
            if (savedMetrics && savedMetrics.length > 0) {
                finalMetrics = savedMetrics.map(m => ({ ...m, weight: Number(m.weight) || 0 }));
            } else if (globalMetrics && globalMetrics.length > 0) {
                finalMetrics = globalMetrics.map(gm => ({ name: gm.name, desc: gm.desc, weight: 0 }));
            }
            
            let mappedProfiles = [];
            if (this.mode === 'EDIT') {
                const candidateList = role.candidateList || [];
                mappedProfiles = (role.profiles || []).map(p => {
                    const uid = p.userId || p.id;
                    const cand = candidateList.find(c => c.id === uid || c.user_id === uid) || {};
                    return { ...cand, ...p, id: uid }; 
                });
            }
            
            this.form = {
                selfId: role.selfId || null,
                title: role.title || '',
                level: savedLevel,
                minSalary: savedMin,
                maxSalary: savedMax,
                evaluationMetrics: finalMetrics,
                mission: role.mission || '',
                responsibilities: summaryText, 
                primaryGoal: role.primaryGoal || '',
                secondaryGoal: role.secondaryGoal || '',
                skills: role.skills ? [...role.skills] : [],
                softSkills: role.softSkills ? [...role.softSkills] : [],
                profiles: mappedProfiles,
                kvdr: finalKvdr
            };
            
            if (this.mode === 'CREATE') {
                this.form.kvdr.influenceScore = 1;
            }
            
            this.isOpen = true;
        },
        
        async fetchLevels() {
             try {
                const orgId = this.$store.state.organization.orgData._id;
                const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                const res = await fetch(`https://api-core-gateway.getboarded.com/organization/organization-config/${orgId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (res.ok) {
                    const json = await res.json();
                    if (json.data && json.data.level && json.data.level.values) {
                        this.orgLevels = json.data.level.values; 
                    }
                }
            } catch (err) {
                console.error("Failed to fetch org levels:", err);
            }
        },

        close() { this.isOpen = false; },
        
        async saveRole() {
            const descriptionArray = this.form.responsibilities ? [{
                msg: this.form.responsibilities + '[ROLE_DESC_SAVE]',
                time: new Date().toISOString()
            }] : [];

            const updatedData = {
                ...this.form,
                roleSummary: this.form.responsibilities,
                description: descriptionArray, 
                kvdrTag: this.kvdrTag,
                clarityScore: this.clarityScore
            };

            if (this.mode === 'CREATE') {
                updatedData.profiles = [];
                updatedData.kvdrRoleProfiles = [];
                updatedData.candidateList = [];
                updatedData.users = [];
            }

            try {
                let savedResult = null;
                
                // 1. Save to FeathersJS MongoDB
                if (this.onSaveCallback) {
                    savedResult = await this.onSaveCallback(updatedData);
                    if (savedResult && savedResult._error) {
                        throw new Error("Unable to save role structure. " + (savedResult.message || ""));
                    }
                }

                // 2. Save everything to Python APIs
                const finalRoleId = this.form.selfId || (savedResult && (savedResult._id || savedResult.id || savedResult.selfId));

                if (finalRoleId) {
                    const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
                    // const apiUrl = process.env.VUE_APP_API_URL;
                    const apiUrl = process.env.VUE_APP_API_URL;
                    // A. Update the main role data
                    await fetch(`${apiUrl}/api/v2/roles/${finalRoleId}`, {
                        method: 'PATCH',
                        headers: { 
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}` 
                        },
                        body: JSON.stringify({
                            title: this.form.title,
                            mission: this.form.mission,
                            primaryGoal: this.form.primaryGoal,
                            secondaryGoal: this.form.secondaryGoal,
                            skills: this.form.skills,
                            softSkills: this.form.softSkills,
                            roleSummary: this.form.responsibilities,
                            kvdrTag: this.kvdrTag,
                            clarityScore: this.clarityScore,
                            kvdr: this.form.kvdr 
                        })
                    });

                    // B. UPDATE THE LEVEL (THE REAL FIX IS HERE)
                    // URL is exactly /api/role/level and body contains role_id
                    if (this.form.level) {
                        try {
                        await fetch(`${apiUrl}/api/v2/roles/${finalRoleId}/metadata`, {
                            method: 'POST',
                            headers: { 
                                'Content-Type': 'application/json', 
                                'Authorization': `Bearer ${token}` 
                            },
                            body: JSON.stringify({ 
                                level: this.form.level,
                                min_salary: this.form.minSalary,
                                max_salary: this.form.maxSalary,
                                evaluation_metrics: this.form.evaluationMetrics
                            })
                        });
                    } catch (e) {
                        console.error("Failed to save full metadata to Python:", e);
                    }
                }
                }
                
                // Success Notification and Close
                if (this.$vs) this.$vs.notify({ title: 'Success', text: 'Role saved successfully', color: 'success' });
                this.close();

            } catch (err) {
                console.error("Vue Modal Save Error:", err);
                if (this.$vs) {
                    this.$vs.notify({ 
                        title: 'Save Failed', 
                        text: err.message || 'There was an error saving the role.', 
                        color: 'danger',
                        time: 4000
                    });
                }
            }
        },

        async saveDetectionMetrics() {
            // If creating a brand new role, we don't have an ID yet. 
            // Just return to the main tab and wait for "Save Changes".
            if (this.mode === 'CREATE' || !this.form.selfId) {
                this.currentView = 'main';
                return;
            }

            this.isSavingKvdr = true;
            try {
                const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
                // const apiUrl = process.env.VUE_APP_API_URL;
                const apiUrl = process.env.VUE_APP_API_URL;
                // Payload specific to KVDR classification & scoring
                const payload = {
                    kvdr: this.form.kvdr,
                    kvdrTag: this.kvdrTag,
                    clarityScore: this.clarityScore
                };

                const res = await fetch(`${apiUrl}/api/v2/roles/${this.form.selfId}`, {
                    method: 'PATCH',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (res.ok) {
                    if (this.$vs) this.$vs.notify({ title: 'Success', text: 'Classification updated.', color: 'success' });
                    
                    // Dispatch event to refresh the visual canvas immediately
                    const updatedData = { ...this.form, kvdrTag: this.kvdrTag, clarityScore: this.clarityScore };
                    window.dispatchEvent(new CustomEvent('kvdr-sandbox-refresh-node', { detail: { roleId: this.form.selfId, data: updatedData } }));
                    
                    this.currentView = 'main'; // Close detection tab
                } else {
                    throw new Error("Failed to save metrics");
                }
            } catch (error) {
                console.error("Error saving detection metrics:", error);
                if (this.$vs) this.$vs.notify({ title: 'Error', text: 'Could not save classification.', color: 'danger' });
            } finally {
                this.isSavingKvdr = false;
            }
        },


        resizeTextarea(e) {
            e.target.style.height = '42px';
            if (e.target.scrollHeight > 42) {
                e.target.style.height = e.target.scrollHeight + 'px';
            }
        },

        formatText(command, value = null) { document.execCommand(command, false, value); },
        updateRichText(field, event) { this.form[field] = event.target.innerHTML; },

        addSkill(type, skill) {
            if (type === 'functional') {
                if (!this.form.skills.includes(skill)) this.form.skills.push(skill);
                // Keep input focused so user can continue searching without closing the box
            } else {
                if (!this.form.softSkills.includes(skill)) this.form.softSkills.push(skill);
            }
        },

        addSkillsFromInput(type) {
            const searchModel = type === 'functional' ? 'funcSkillSearch' : 'softSkillSearch';
            const skillsArray = type === 'functional' ? this.form.skills : this.form.softSkills;

            const skillsToAdd = this[searchModel].split(',').map(s => s.trim()).filter(s => s.length > 0);
            skillsToAdd.forEach(skill => {
                if (!skillsArray.find(s => s.toLowerCase() === skill.toLowerCase())) skillsArray.push(skill);
            });
            this[searchModel] = '';
        },
        
        removeSkill(type, index) {
            if (type === 'functional') this.form.skills.splice(index, 1);
            else this.form.softSkills.splice(index, 1);
        },
        
        async generateAIContent() {
            if (!this.form.title) {
                if (this.$vs) this.$vs.notify({ title: 'Title Required', text: 'Please enter a Role Title first.', color: 'warning' });
                return;
            }
            this.isGeneratingJD = true;
            try {
                const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
                // const apiUrl = process.env.VUE_APP_API_URL || 'https://api.getboarded.tech'; 
                const apiUrl = process.env.VUE_APP_API_URL;
                const payload = {
                    role_title: this.form.title,
                    level: this.form.level || "", // <--- ADD THIS LINE
                    technical_skills: this.form.skills, 
                    soft_skills: this.form.softSkills,
                    existing_description: this.form.responsibilities
                };
                
                // FIX FOR 422: If it's EDIT mode, send the real ID. 
                // If it's CREATE mode, strictly send "new_role" so FastAPI doesn't crash.
                if (this.mode === 'EDIT' && this.form.selfId) {
                    payload.role_id = this.form.selfId;
                } else {
                    payload.role_id = "new_role"; 
                }

                const response = await fetch(`${apiUrl}/api/generate-role-description`, {
                    method: 'POST', 
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) throw new Error(`API request failed with status ${response.status}`);
                const data = await response.json();
                
                if (data.description || data.role_description) this.form.responsibilities = data.description || data.role_description;
                
                if (data.recommended_technical_skills) {
                    const newSkills = data.recommended_technical_skills.filter(skill => !this.form.skills.find(s => s.toLowerCase() === skill.toLowerCase()));
                    this.funcSkillSearch = newSkills.join(', ');
                }

                if (data.recommended_soft_skills) {
                    const newSkills = data.recommended_soft_skills.filter(skill => !this.form.softSkills.find(s => s.toLowerCase() === skill.toLowerCase()));
                    this.softSkillSearch = newSkills.join(', ');
                }
                if (this.$vs) this.$vs.notify({ title: 'Success', text: 'AI successfully generated role details!', color: 'success' });
            } catch (error) {
                console.error("AI Generation Error: ", error);
                if (this.$vs) this.$vs.notify({ title: 'Error', text: 'Failed to generate details. Try again.', color: 'danger' });
            } finally {
                this.isGeneratingJD = false;
            }
        },

        toggleArrayItem(arr, item) {
            const index = arr.indexOf(item);
            if (index > -1) arr.splice(index, 1);
            else arr.push(item);
        },
        triggerTalentCard(userId) { window.dispatchEvent(new CustomEvent('show-talent-card', { detail: { userId } })); },
        getAvatarUrl(user) {
            const url = user.imageUrl || user.image_url || user.profilePictureUrl || user.avatar;
            if (url && url.startsWith('http')) return url;
            if (url) return `https://gtbrdd-storage.s3.us-west-2.amazonaws.com/editor/profile-pictures/${url}`;
            return `https://hostedboringavatars.vercel.app/api/beam?name=${encodeURIComponent(user.name || user.firstName || 'User')}`;
        },

        openJDPreview() {
            // 1. Create a tiny helper to keep the HTML string clean
            const t = (key) => this.$t(`orgDashboard.userDashboard.evaluation.${key}`);

            // 2. Build the HTML using the translated keys
            this.generatedJD = `
                <h3 style="font-size: 22px; color: #0f172a; margin-bottom: 8px;">
                    ${t('jobdescription')}: ${this.form.title || t('untitledrole')}
                </h3>
                
                <p style="margin: 4px 0;"><strong>Level:</strong> ${this.form.level || t('notspecified')}</p>
                
                <p style="margin: 4px 0;"><strong>${t('mission')}:</strong> ${this.form.mission || t('todriveorgsuccess')}</p>
                
                <p style="margin: 4px 0;"><strong>Classification:</strong> ${this.kvdrTag} ${t('role')}</p>
                
                <h4 style="margin-top: 20px; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px;">${t('roledescription')}</h4>
                <div style="line-height: 1.6;">${this.form.responsibilities || `<p>${t('nodescription')}</p>`}</div>
                
                <h4 style="margin-top: 20px; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px;">${t('functionalSkills')}</h4>
                <ul style="padding-left: 20px;">
                    ${this.form.skills.length ? this.form.skills.map(s => `<li>${s}</li>`).join('') : `<li>${t('nonespecified')}</li>`}
                </ul>
                
                <h4 style="margin-top: 20px; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px;">${t('softSkills')}</h4>
                <ul style="padding-left: 20px;">
                    ${this.form.softSkills.length ? this.form.softSkills.map(s => `<li>${s}</li>`).join('') : `<li>${t('nonespecified')}</li>`}
                </ul>
                
                <h4 style="margin-top: 20px; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px;">${t('goals')}</h4>
                <p style="margin: 4px 0;"><strong>${t('primarygoal')}:</strong> ${this.form.primaryGoal || t('notspecified')}</p>
                <p style="margin: 4px 0;"><strong>${t('secondarygoal')}:</strong> ${this.form.secondaryGoal || t('notspecified')}</p>
            `;
            
            this.showJDModal = true;
        },

        downloadJD(format) {
            let content = this.generatedJD;
            let filename = `${this.form.title.replace(/\s+/g, '_')}_JD`;
            let type = '';

            if (format === 'txt') {
                content = content.replace(/<[^>]+>/g, '\n'); 
                filename += '.txt';
                type = 'text/plain';
            } else if (format === 'doc') {
                content = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'></head><body>${content}</body></html>`;
                filename += '.doc';
                type = 'application/msword';
            } else if (format === 'pdf') {
                 const win = window.open('', '', 'height=700,width=700');
                 win.document.write(`<html><head><title>${filename}</title><style>body{font-family:sans-serif; padding:30px; color: #333; line-height: 1.6;}</style></head><body>${content}</body></html>`);
                 win.document.close();
                 setTimeout(() => win.print(), 500); 
                 return;
            }

            const blob = new Blob([content], { type });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(url);
        }
    },
    watch: {
        currentView(newVal) {
            // When the view switches TO the detection layer...
            if (newVal === 'detection') {
                // Wait for the DOM to finish rendering the sliders
                this.$nextTick(() => {
                    // Find ONLY the sliders inside the detection modal
                    const sliders = this.$el.querySelectorAll('.detection-modal .slider');
                    if (sliders.length > 0) {
                        sliders.forEach(slider => {
                            // This logic is the same as before, but now it runs at the right time
                            const min = slider.min;
                            const max = slider.max;
                            const val = slider.value; // v-model ensures this is the correct current value
                            const percentage = ((val - min) * 100) / (max - min);
                            slider.style.setProperty('--fill-percent', `${percentage}%`);
                        });
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
.role-editor-overlay { 
    position: fixed; 
    top: 0; left: 0; 
    width: 100vw; height: 100vh; 
    background: rgba(15, 23, 42, 0.6); /* Solid dark, no blur */
    display: flex; align-items: center; justify-content: center; 
    z-index: 20000; 
    backdrop-filter: none !important; /* Force disable blur */
}
.role-editor-overlay.metrics-overlay { 
    z-index: 25000; 
    background: rgba(15, 23, 42, 0.4); 
    backdrop-filter: none !important; /* Force disable blur */
}
.role-editor-modal { background: #fff; width: 900px; max-height: 95vh; border-radius: 12px; display: flex; flex-direction: column; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); animation: modalIn 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
@keyframes modalIn { from { opacity: 0; transform: translateY(20px) scale(0.95); } to { opacity: 1; transform: translateY(0) scale(1); } }

.modal-header { padding: 20px 24px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; background: #fff; border-radius: 12px 12px 0 0; }
.modal-title { font-size: 18px; font-weight: 700; color: #0f172a; margin: 0; }
.subtitle { font-weight: 400; color: #64748b; font-size: 14px; }
.header-right { display: flex; align-items: center; gap: 12px; }
.close-btn { background: none; border: none; font-size: 24px; cursor: pointer; color: #94a3b8; }
.close-btn:hover { color: #0f172a; }

.modal-body { padding: 20px 24px; overflow-y: auto; flex: 1; display: flex; flex-direction: column; }
.main-layout-container { display: flex; gap: 28px; margin-top: 10px; }
.main-content-column { flex: 2; display: flex; flex-direction: column; gap: 18px; min-width: 0; }
.skills-column { flex: 1; display: flex; flex-direction: column; gap: 24px; min-width: 0; border-left: 1px solid #f1f5f9; padding-left: 20px; }

.modal-footer { padding: 16px 24px; border-top: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; background: #fff; border-radius: 0 0 12px 12px; }

.form-group { display: flex; flex-direction: column; gap: 6px; }
.form-group label { font-size: 11px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 0; }
.form-control { width: 100%; padding: 10px 12px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 14px; font-family: inherit; transition: border-color 0.2s; box-sizing: border-box; outline: none; }
.form-control:focus { border-color: #F59E0B; box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1); }
.form-group-box { padding: 16px; border: 1px solid #e2e8f0; border-radius: 8px; background: #f8fafc; display: flex; flex-direction: column; gap: 12px; }
.box-title { display: flex; align-items: center; gap: 8px; font-weight: 700; color: #0f172a; font-size: 12px; }

.designation-input { width: 100%; padding: 8px 0; border: none; border-bottom: 2px solid #e2e8f0; border-radius: 0; font-size: 24px; font-weight: 700; color: #1e293b; background: transparent; outline: none; transition: border-color 0.2s; }
.designation-input::placeholder { color: #cbd5e1; font-weight: 600; }
.designation-input:focus { border-bottom-color: #F59E0B; }

.level-mission-row { display: flex; gap: 16px; align-items: flex-start; }
.select-fixed-height { height: 42px; }
.auto-expand-textarea { min-height: 42px; height: 42px; resize: none; overflow: hidden; line-height: 1.4; } 

.search-wrapper { margin-top: 4px; margin-bottom: 8px; position: relative; }
.tags-container { display: flex; flex-wrap: wrap; gap: 6px; min-height: 28px; }
.skill-tag { background: #fef3c7; color: #d97706; padding: 4px 10px; border-radius: 16px; font-size: 12px; display: flex; align-items: center; gap: 6px; border: 1px solid #fde68a; }
.remove-skill { cursor: pointer; font-weight: bold; }

/* Modified Custom Dark Floating Dropdown List */
.minimal-input-wrapper {
    position: relative;
    margin-bottom: 8px;
    margin-top: 4px;
}
.minimal-input {
    width: 100%;
    padding: 8px 24px 8px 0;
    border: none;
    border-bottom: 2px solid #e2e8f0;
    border-radius: 0;
    font-size: 15px;
    color: #475569;
    background: transparent;
    outline: none;
    transition: border-color 0.2s;
}
.minimal-input::placeholder {
    color: #64748b;
    font-weight: 400;
}
.minimal-input:focus {
    border-bottom-color: #F59E0B;
    box-shadow: none;
}
.dropdown-caret {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 10px;
    color: #0f172a;
    pointer-events: none;
}

.side-dropdown-list { 
    position: absolute; 
    top: calc(100% + 4px); /* Opens directly below the input */
    left: 0; 
    width: 100%; /* Matches input width perfectly */
    z-index: 10000; 
    list-style: none; 
    margin: 0; 
    padding: 8px 0; 
    max-height: 250px; 
    overflow-y: auto; 
    border-radius: 8px; 
    background: #0f172a; 
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.6); 
}
.side-dropdown-list li { 
    padding: 10px 16px; 
    font-size: 13px; 
    color: #e2e8f0; 
    border-bottom: none; 
    cursor: pointer; 
    display: flex; 
    justify-content: space-between; 
    align-items: center; 
    transition: background 0.1s, color 0.1s; 
}
.side-dropdown-list li:hover { 
    background: #1e293b; 
    color: #fff; 
}
.side-dropdown-list::-webkit-scrollbar { width: 6px; }
.side-dropdown-list::-webkit-scrollbar-track { background: transparent; }
.side-dropdown-list::-webkit-scrollbar-thumb { background: #475569; border-radius: 4px; }
.check-icon { color: #34d399; font-weight: bold; font-size: 14px; }
.no-results { color: #64748b !important; font-style: italic; cursor: default !important; }
.no-results:hover { background: #0f172a !important; color: #64748b !important; }

/* JD Preview Modal Layout Fixes */
.jd-preview-overlay { z-index: 21000; }
.jd-preview-modal { 
    background: #fff; 
    width: 750px; 
    max-height: 90vh; 
    border-radius: 12px; 
    display: flex; 
    flex-direction: column; 
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4); 
    animation: modalIn 0.2s ease-out; 
    overflow: hidden; /* Restrict bleeding over border-radius */
}
.jd-toolbar { padding: 12px 24px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; display: flex; gap: 12px; align-items: center; }
.toolbar-label { font-size: 13px; font-weight: 600; color: #64748b; margin-right: 4px; }
.dl-btn { display: flex; align-items: center; gap: 6px; padding: 6px 14px; background: #fff; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 13px; font-weight: 600; color: #475569; cursor: pointer; transition: all 0.2s; }
.dl-btn svg { width: 14px; height: 14px; color: #F59E0B; }
.dl-btn:hover { background: #fefce8; border-color: #fde68a; color: #b45309; }
.jd-body { 
    padding: 30px; 
    padding-bottom: 60px !important; /* Extra bottom padding prevents Goals from clipping */
    background: #fff; 
    flex: 1; 
    overflow-y: auto; 
}
.readonly-jd { 
    border: none !important; /* Removes the inner gray box border */
    padding: 0 !important; 
    margin-bottom: 20px; /* Safe space at the bottom */
    font-family: inherit; 
    color: #334155; 
}
.label-row-with-ai { display: flex; justify-content: space-between; align-items: center; margin-bottom: 2px; }
.ai-icon-btn { background: transparent; border: none; color: #64748b; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 4px; border-radius: 4px; transition: color 0.2s, background-color 0.2s; }
.ai-icon-btn:hover:not(:disabled) { background: #fefce8; color: #F59E0B; }
.loading-spinner { width: 14px; height: 14px; border: 2px solid #F59E0B; border-top-color: transparent; border-radius: 50%; animation: spin 1s linear infinite; }
.rich-text-toolbar { display: flex; gap: 4px; padding: 4px 8px; background: #f8fafc; border: 1px solid #e2e8f0; border-bottom: none; border-radius: 6px 6px 0 0; }
.rich-text-toolbar button, .rich-text-toolbar select { background: none; border: 1px solid transparent; border-radius: 4px; cursor: pointer; padding: 4px 8px; font-size: 14px; color: #475569; }
.rich-text-toolbar button:hover { background: #e2e8f0; }
.rich-text-editor { min-height: 120px; padding: 12px; border: 1px solid #e2e8f0; border-radius: 0 0 6px 6px; font-size: 14px; outline: none; }
.rich-text-editor:focus { border-color: #F59E0B; }
.rich-text-editor >>> ul { list-style-type: disc !important; padding-left: 24px !important; margin-top: 8px !important; margin-bottom: 8px !important; }
.rich-text-editor >>> ol { list-style-type: decimal !important; padding-left: 24px !important; margin-top: 8px !important; margin-bottom: 8px !important; }
.rich-text-editor >>> li { display: list-item !important; list-style-position: outside !important; margin-bottom: 4px !important; }

.kvdr-badge { padding: 4px 10px; border-radius: 12px; font-size: 12px; font-weight: 700; cursor: pointer; transition: 0.2s; position: relative; }
.kvdr-badge.nvr { background: #f1f5f9; color: #64748b; border: 1px solid #cbd5e1; }
.kvdr-badge.svr { background: #e0f2fe; color: #0284c7; border: 1px solid #bae6fd; }
.kvdr-badge.kvdr {
    background: #E6F7F0;
    color: #067647;
    border: 1px solid #A3E6C8;
}
.kvdr-badge:hover { filter: brightness(0.95); }
.badge-tooltip { visibility: hidden; position: absolute; right: 0; top: 110%; background: #1e293b; color: #fff; padding: 6px 10px; border-radius: 6px; font-size: 11px; width: 220px; text-align: center; font-weight: 400; opacity: 0; transition: opacity 0.2s; pointer-events: none; z-index: 50; }
.kvdr-badge:hover .badge-tooltip { visibility: visible; opacity: 1; }

.assigned-candidates-section { background: #f8fafc; border: 1px solid #e2e8f0; padding: 12px 16px; border-radius: 8px; margin-bottom: 10px; }
.assigned-candidates-section label { display: block; font-size: 11px; font-weight: 700; color: #475569; margin-bottom: 10px; text-transform: uppercase; }
.candidate-avatars { display: flex; gap: 8px; flex-wrap: wrap; }
.avatar-wrapper { position: relative; cursor: pointer; transition: transform 0.2s; }
.avatar-wrapper:hover { transform: translateY(-2px); z-index: 10; }
.candidate-avatar { width: 36px; height: 36px; border-radius: 50%; border: 2px solid #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.1); object-fit: cover; }
.avatar-wrapper .tooltip { position: absolute; bottom: -25px; left: 50%; transform: translateX(-50%); background: #1e293b; color: white; padding: 4px 8px; border-radius: 4px; font-size: 11px; opacity: 0; pointer-events: none; white-space: nowrap; transition: 0.2s; }
.avatar-wrapper:hover .tooltip { opacity: 1; }

.classification-box { border-radius: 8px; padding: 16px; display: flex; justify-content: space-between; align-items: center; }
.classification-box.nvr { background: #fff; border: 1px solid #e2e8f0; }
.classification-box.nvr .class-label { color: #64748b; }
.classification-box.nvr .class-val, .classification-box.nvr .class-score { color: #1e293b; }
.classification-box.svr { background: #e0f2fe; border: 1px solid #bae6fd; }
.classification-box.svr .class-label { color: #0284c7; }
.classification-box.svr .class-val, .classification-box.svr .class-score { color: #0369a1; }
.classification-box.kvdr { background: #fef3c7; border: 1px solid #fde68a; }
.classification-box.kvdr .class-label { color: #b45309; }
.classification-box.kvdr .class-val, .classification-box.kvdr .class-score { color: #92400e; }
.class-label { font-size: 10px; font-weight: 700; margin-bottom: 4px; text-transform: uppercase; }
.class-val { font-size: 24px; font-weight: 800; }
.class-desc { font-size: 12px; color: #0284c7; margin-top: 4px; }
.class-score { font-size: 20px; font-weight: 700; }
.class-score span { font-size: 28px; }
.btn-group { display: flex; gap: 8px; }
.btn-group button { flex: 1; padding: 10px; background: #fff; border: 1px solid #e2e8f0; border-radius: 6px; cursor: pointer; font-weight: 600; color: #475569; }
.btn-group button.active { background: #fef3c7; border-color: #fde68a; color: #d97706; }
.pill-group { display: flex; flex-wrap: wrap; gap: 8px; }
.pill { padding: 6px 14px; border-radius: 20px; border: 1px solid #cbd5e1; background: #fff; font-size: 13px; color: #475569; cursor: pointer; }
.pill.active { background: #fef3c7; border-color: #fde68a; color: #d97706; font-weight: 600; }
.grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.slider { width: 100%; appearance: none; background: #e2e8f0; height: 6px; border-radius: 4px; outline: none; margin-top: 8px; }
.slider::-webkit-slider-thumb { -webkit-appearance: none; appearance: none; width: 20px; height: 20px; border-radius: 50%; background: #3b82f6; cursor: pointer; }
.yellow-slider::-webkit-slider-thumb { background: #F59E0B; }
.slider-labels { display: flex; justify-content: space-between; font-size: 11px; color: #94a3b8; margin-top: 6px; }
.score-badge { float: right; background: #e2e8f0; padding: 2px 8px; border-radius: 10px; color: #0f172a; }
.clarity-score-box { text-align: center; background: #fff; padding: 12px; border-radius: 6px; border: 1px dashed #cbd5e1; color: #475569; font-size: 14px; }

.btn-secondary { padding: 10px 20px; background: #fff; border: 1px solid #cbd5e1; border-radius: 6px; font-weight: 600; color: #475569; cursor: pointer; transition: 0.2s; }
.btn-secondary:hover { background: #f8fafc; }
.btn-primary { padding: 10px 20px; background: #FBBF24; border: none; border-radius: 6px; font-weight: 600; color: #fff; cursor: pointer; transition: opacity 0.2s; }
.btn-primary:hover { opacity: 0.9; }
.invisible-scroll-y::-webkit-scrollbar { width: 6px; }
.invisible-scroll-y::-webkit-scrollbar-track { background: transparent; }
.invisible-scroll-y::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

.title-level-wrapper { 
    display: flex; 
    align-items: baseline; 
    border-bottom: 2px solid #e2e8f0; 
    padding-bottom: 4px; 
    margin-bottom: 12px; 
    transition: border-color 0.2s; 
}
.title-level-wrapper:focus-within { 
    border-bottom-color: #F59E0B; 
}

/* Stripped down title input */
.designation-input.minimal-title { 
    flex: 1; 
    border: none; 
    padding: 0; 
    margin: 0; 
}
.designation-input.minimal-title:focus { 
    border-bottom-color: transparent; /* Handled by wrapper now */
}

/* Minimal Level Selector attached to the right */
.level-selector { 
    position: relative; 
    display: inline-flex; 
    align-items: center; 
}
.level-select-minimal { 
    appearance: none; 
    background: transparent; 
    border: none; 
    padding: 4px 20px 4px 8px; 
    font-size: 13px; 
    font-weight: 600; 
    color: #64748b; 
    cursor: pointer; 
    outline: none; 
    text-align: right;
}
.level-select-minimal:focus, .level-select-minimal:hover { 
    color: #F59E0B; 
}
.level-selector .dropdown-caret { 
    position: absolute; 
    right: 4px; 
    top: 50%;
    transform: translateY(-50%);
    font-size: 10px; 
    color: #94a3b8; 
    pointer-events: none; 
}

/* Minimal Mission/Description Input */
.mission-group { 
    margin-bottom: 24px; 
}

.minimal-mission-input { 
    width: 100%; 
    padding: 8px 0; 
    border: none; 
    border-bottom: 2px solid #e2e8f0; /* Adds the line beneath */
    border-radius: 0;
    font-size: 14px; 
    color: #1e293b; 
    background: transparent; 
    outline: none; 
    line-height: 1.5;
    font-family: inherit;
    transition: border-color 0.2s;
}

.minimal-mission-input::placeholder { 
    color: #cbd5e1; 
    font-weight: 500; 
}

/* Adds the yellow highlight when you click into the input */
.minimal-mission-input:focus {
    border-bottom-color: #F59E0B;
}

.minimal-goals-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
}

/* Minimal Underlined Input Style */
.minimal-underline-input {
    width: 100%;
    padding: 8px 0;
    border: none;
    border-bottom: 2px solid #e2e8f0;
    border-radius: 0;
    font-size: 14px;
    color: #1e293b;
    background: transparent;
    outline: none;
    font-family: inherit;
    transition: border-color 0.2s;
}

.minimal-underline-input::placeholder {
    color: #cbd5e1;
    font-weight: 500;
}

.minimal-underline-input:focus {
    border-bottom-color: #F59E0B;
}
.detection-modal .modal-body {
    gap: 22px;
    background: #f8fafc; /* Light grey background for the whole panel */
    display: flex;
    flex-direction: column;
    gap: 28px; /* Consistent spacing between sections */
    padding: 24px;
}

/* General form group and label styling */
.detection-modal .form-group {
    gap: 12px;
}
.detection-modal .form-group label {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    text-transform: none; /* Change from uppercase */
    letter-spacing: 0;
}
.detection-modal .label-hint {
    font-weight: 400;
    color: #94a3b8;
}

/* 1. CLASSIFICATION BOX REDESIGN */
.classification-box {
    border-radius: 8px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border: 1px solid transparent;
}
.classification-box.kvdr {
    background: #E6F7F0; /* Light Green */
    border-color: #A3E6C8;
}
.classification-box.kvdr .class-val, .classification-box.kvdr .class-score { color: #067647; /* Dark Green */}
.classification-box.kvdr .class-label, .classification-box.kvdr .class-desc { color: #059669; }

.classification-box.svr {
    background: #E0F2FE; /* Light Blue */
    border-color: #bae6fd;
}
.classification-box.svr .class-val, .classification-box.svr .class-score { color: #0369a1; }
.classification-box.svr .class-label, .classification-box.svr .class-desc { color: #0284c7; }

.classification-box.nvr {
    border-color: #cbd5e1;
    background: #f1f5f9;
}
.classification-box.nvr .class-val, .classification-box.nvr .class-score { color: #64748b;}
.classification-box.nvr .class-label, .classification-box.nvr .class-desc { color: #64748b; }
.class-label { font-size: 11px; font-weight: 700; margin-bottom: 2px; text-transform: uppercase; }
.class-val { font-size: 22px; font-weight: 700; }
.class-desc { font-size: 13px; margin-top: 4px; }
.class-right { text-align: right; }
.class-score { font-size: 18px; font-weight: 600; }
.class-score span { font-size: 24px; font-weight: 700; }

/* 2. VALUE DRIVER BUTTONS REDESIGN */
.btn-group { display: flex; gap: 12px; }
.btn-group button {
    flex: 1;
    padding: 12px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    color: #475569;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
}
.btn-group button svg { color: #94a3b8; transition: color 0.2s; }
.btn-group button:hover { border-color: #cbd5e1; background: #f8fafc; }
.btn-group button.active {
    background: #FFFBEB; /* Light Orange */
    border-color: #F59E0B; /* Orange */
    color: #B45309; /* Dark Orange */
}
.btn-group button.active svg { color: #F59E0B; }

/* 3. VALUE PILLS REDESIGN */
.pill-group { display: flex; flex-wrap: wrap; gap: 8px; }
.pill {
    padding: 6px 16px;
    border-radius: 20px;
    border: 1px solid #cbd5e1;
    background: #fff;
    font-size: 14px;
    color: #475569;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;
}
.pill:hover { border-color: #94a3b8; }
.pill.active {
    background: #F59E0B; /* Orange */
    border-color: #F59E0B;
    color: #fff;
    font-weight: 600;
}
.other-value-input { margin-top: 8px; }


/* 4. BUSINESS TERMS CHECKBOXES REDESIGN */
.grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.checkbox-button input[type="checkbox"] { display: none; } /* Hide the original checkbox */
.checkbox-content {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border: 1px solid #e2e8f0;
    background-color: #fff;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    color: #475569;
    font-weight: 500;
}
.checkbox-button:hover .checkbox-content { border-color: #cbd5e1; }
.custom-check {
    width: 20px;
    height: 20px;
    border: 1.5px solid #cbd5e1;
    border-radius: 50%;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}
.custom-check svg { opacity: 0; transform: scale(0.5); transition: all 0.2s ease; }

/* Checked State */
.checkbox-button input[type="checkbox"]:checked + .checkbox-content {
    border-color: #F59E0B;
    background: #FFFBEB;
    color: #B45309;
    font-weight: 600;
}
.checkbox-button input[type="checkbox"]:checked + .checkbox-content .custom-check {
    background: #F59E0B;
    border-color: #F59E0B;
}
.checkbox-button input[type="checkbox"]:checked + .checkbox-content .custom-check svg {
    opacity: 1;
    transform: scale(1);
}

/* 5. SLIDERS REDESIGN */
.score-badge {
    float: right;
    background: #e2e8f0;
    padding: 2px 8px;
    border-radius: 10px;
    color: #0f172a;
    font-weight: 600;
    font-size: 12px;
}
.slider {
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    height: 6px;
    border-radius: 4px;
    outline: none;
    margin-top: 8px;
    /* This is the key: a gradient that uses our JS variable */
    background: linear-gradient(to right, #F59E0B 0%, #F59E0B var(--fill-percent), #e2e8f0 var(--fill-percent), #e2e8f0 100%);
}

.slider.orange-slider::-webkit-slider-thumb { background: #F59E0B; }
.slider.orange-slider::-moz-range-thumb { background: #F59E0B; }

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 3px solid #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    cursor: pointer;
    /* Move thumb up slightly to center it on the track */
    margin-top: -7px; 
}

.slider::-moz-range-thumb {
    width: 14px; /* Mozilla needs different dimensions */
    height: 14px;
    border-radius: 50%;
    border: 3px solid #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    cursor: pointer;
}
.slider-labels {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #64748b;
    margin-top: 6px;
}
.level-selector {
    position: relative; /* This is crucial for positioning the arrow */
    display: inline-flex;
    align-items: center;
}

/* The clickable button part */
.level-select-minimal {
    appearance: none;
    background: transparent;
    border: none;
    /* Add padding on the right to make space for the arrow */
    padding: 4px 20px 4px 8px;
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    outline: none;
    text-align: right; /* Aligns text to the right */
    transition: color 0.2s;
    min-width: 100px; /* Prevents the button from becoming too small */
}

.level-select-minimal:hover {
    color: #F59E0B;
}

/* Position the arrow on top of the button's padding */
.level-selector .dropdown-caret {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 10px;
    color: #94a3b8;
    pointer-events: none; /* Allows clicks to go through to the button */
}

/* The floating dropdown menu */
.level-dropdown-menu {
    position: absolute;
    top: calc(100% + 4px); /* Position it right below the button */
    right: 0;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    list-style: none;
    padding: 4px 0;
    margin: 0;
    width: 200px;
    z-index: 100;
    overflow: hidden;
}

/* The individual option items */
.level-dropdown-menu li {
    padding: 10px 16px;
    font-size: 14px;
    color: #1e293b; /* Fix: Black text color */
    cursor: pointer;
    text-align: left; /* Fix: Left aligned */
    border-bottom: 1px solid #f1f5f9; /* Fix: Separator line */
    transition: background-color 0.2s;
}
.level-dropdown-menu li:last-child {
    border-bottom: none; /* Remove line from the last item */
}
.level-dropdown-menu li:hover {
    background-color: #f8fafc; /* Add a subtle hover effect */
}
.settings-icon-btn {
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    color: #475569;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}
.settings-icon-btn:hover { background: #e2e8f0; color: #0f172a; }

/* Metrics Panel Styling */
.metrics-section-box {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 20px;
}
.metrics-section-title { font-size: 15px; font-weight: 700; color: #1e293b; margin: 0 0 4px 0; }
.metrics-section-desc { font-size: 13px; color: #64748b; margin: 0 0 16px 0; }

.salary-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.salary-input-group label { display: block; font-size: 11px; font-weight: 700; color: #475569; text-transform: uppercase; margin-bottom: 6px; }
.input-with-currency { position: relative; }
.currency-symbol { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #64748b; font-weight: 600; font-size: 14px; }
.input-with-currency input { padding-left: 28px; width: 100%; }

.weight-total-badge { padding: 4px 10px; border-radius: 12px; font-size: 12px; font-weight: 700; }
.weight-total-badge.valid { background: #E6F7F0; color: #067647; border: 1px solid #A3E6C8; }
.weight-total-badge.invalid { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }

.metric-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-bottom: 1px solid #f8fafc; }
.metric-row:last-child { border-bottom: none; }
.metric-name { font-weight: 600; color: #334155; font-size: 14px; }
.metric-desc { font-size: 12px; color: #94a3b8; font-style: italic; margin-top: 2px; }
.metric-weight-input { position: relative; width: 80px; }
.metric-weight-input input { padding-right: 24px; font-weight: 600; }
.percent-sign { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: #64748b; font-size: 13px; font-weight: 500;}
.settings-icon-btn {
    background: transparent;
    border: none;
    color: #94a3b8;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}
.settings-icon-btn:hover { background: #f1f5f9; color: #0f172a; }

.input-with-currency { position: relative; }
.currency-symbol { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #64748b; font-weight: 700; font-size: 15px; }
.input-with-currency input { padding-left: 28px; width: 100%; border-color: #cbd5e1; }

.metric-row { 
    display: flex; 
    justify-content: space-between; 
    align-items: center; 
    padding: 12px 10px; /* Adjusted padding for breathing room */
    border-bottom: 1px solid #f1f5f9; 
    border-radius: 8px;
    transition: background-color 0.2s ease; /* Smooth hover effect */
}

.metric-row:hover {
    background-color: #f8fafc; /* Subtle highlight on hover */
}

.metric-row:last-child { 
    border-bottom: none; 
}
.metric-weight-input input {
    /* Removes the browser spinner arrows from the number input */
    -moz-appearance: textfield;
}
.metric-weight-input input::-webkit-outer-spin-button,
.metric-weight-input input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}


.metrics-inner-modal .modal-body {
    padding: 24px;
    overflow-y: auto;
    flex: 1; 
    -webkit-overflow-scrolling: touch; /* Smooth scroll for trackpads/mac */
    transform: translateZ(0); /* 👈 ADD THIS: Forces GPU Hardware Acceleration */
    will-change: transform;
}
.action-icon-btn {
    background: transparent;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #94a3b8;
}
.action-icon-btn.edit-btn:hover { background: #eff6ff; color: #3b82f6; transform: scale(1.05); }
.action-icon-btn.delete-btn:hover { background: #fef2f2; color: #ef4444; transform: scale(1.05); }
.add-metric-dashed-btn {
    width: 100%;
    padding: 10px;
    background: transparent;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    color: #64748b;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}
.add-metric-dashed-btn:hover {
    border-color: #F59E0B;
    color: #F59E0B;
    background: #fffbeb;
}

.metrics-inner-modal { 
    background: #fff; 
    width: 750px; 
    max-height: 85vh !important; 
    border-radius: 12px; 
    display: flex; 
    flex-direction: column; 
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2); /* Lighter shadow = less lag */
    overflow: hidden; 
}

.metrics-inner-modal .modal-body {
    flex: 1; 
    overflow-y: auto !important; 
    overflow-x: hidden;
    padding: 24px;
    
    /* These three lines force the browser's Graphics Card to handle the scroll */
    -webkit-overflow-scrolling: touch; 
    transform: translateZ(0); 
    will-change: transform;
}

/* 3. Strip all borders and heights that cause nested scroll confusion */
.metrics-list-container { 
    max-height: none !important; 
    overflow: visible !important; 
    border-top: 1px solid #e2e8f0; 
    padding-top: 12px; 
    margin-top: 12px;
}

/* 4. Remove heavy transition animations on hover */
.metric-row { 
    display: flex; 
    justify-content: space-between; 
    align-items: center; 
    padding: 12px 8px; 
    border-bottom: 1px solid #f1f5f9; 
    border-radius: 8px;
    /* Removed "transition: all" here to stop lag when scrolling fast */
}
.metric-row:hover { background-color: #f8fafc; }
.metric-row:last-child { border-bottom: none; }

/* 6. Clean, lightweight custom scrollbar */
.metrics-inner-modal .modal-body::-webkit-scrollbar {
    width: 6px;
}
.metrics-inner-modal .modal-body::-webkit-scrollbar-track {
    background: transparent;
}
.metrics-inner-modal .modal-body::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}
</style>